// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qORy","question":"styles_question__Dsi2l","description":"styles_description__2K0lX"};